"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DayHeader = DayHeader;
exports.formatMonth = formatMonth;
exports.formatDay = formatDay;
exports.WeekDateHeader = exports.WeekPicker = exports.VerticalWeekPicker = exports.MonthHeader = exports.MonthPicker = exports.RightChevron = exports.LeftChevron = exports.CalendarHeader = exports.WeekGrid = exports.Grid = void 0;

var React = _interopRequireWildcard(require("react"));

var _eachWeekOfInterval = _interopRequireDefault(require("date-fns/eachWeekOfInterval"));

var _startOfMonth = _interopRequireDefault(require("date-fns/startOfMonth"));

var _lastDayOfMonth = _interopRequireDefault(require("date-fns/lastDayOfMonth"));

var _add = _interopRequireDefault(require("date-fns/add"));

var _sub = _interopRequireDefault(require("date-fns/sub"));

var _range = _interopRequireDefault(require("lodash/range"));

var _format = _interopRequireDefault(require("date-fns/format"));

var _isSameDay = _interopRequireDefault(require("date-fns/isSameDay"));

var _button = require("../button");

var _classify = _interopRequireDefault(require("../utils/classify"));

var _calendarModule = _interopRequireDefault(require("./calendar.module.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// import IconButton from 'src'
const Grid = ({
  month,
  starts = 0,
  eventDates = [],
  selectedDate,
  onChange,
  size = "medium"
}) => {
  const firstDay = (0, _startOfMonth.default)(month);
  const lastDay = (0, _lastDayOfMonth.default)(month);
  const weeks = (0, _eachWeekOfInterval.default)({
    start: firstDay,
    end: lastDay
  }, {
    weekStartsOn: starts
  });
  return /*#__PURE__*/React.createElement("div", {
    className: _calendarModule.default.calendarGrid
  }, weeks.map((firstDay, _index) => /*#__PURE__*/React.createElement(WeekGrid, {
    key: firstDay.toISOString(),
    firstDay: firstDay,
    eventDates: eventDates,
    selectedDate: selectedDate,
    onChange: onChange,
    size: size
  })));
};

exports.Grid = Grid;

const WeekGrid = ({
  className = _calendarModule.default.weekRow,
  size = "medium",
  firstDay,
  eventDates,
  selectedDate,
  onChange,
  formatDate = day => (0, _format.default)(day, "d")
}) => {
  const monthIndex = firstDay.getMonth();
  const days = (0, _range.default)(7).map(days => (0, _add.default)(firstDay, {
    days
  }));
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.default)(size && _calendarModule.default[size], className)
  }, days.map(day => {
    const dateString = formatDate(day);
    const hasEvent = eventDates.some(eventDate => (0, _isSameDay.default)(day, eventDate));
    const dayClassName = (0, _classify.default)(_calendarModule.default.calendarDate, {
      [_calendarModule.default.currentMonthDate]: monthIndex != null ? day.getMonth() === monthIndex : true,
      [_calendarModule.default.hasEvent]: hasEvent,
      [_calendarModule.default.selectedDate]: selectedDate ? (0, _isSameDay.default)(day, selectedDate) : false
    });
    return /*#__PURE__*/React.createElement("div", {
      key: day.toISOString(),
      className: dayClassName,
      title: day
    }, hasEvent ? /*#__PURE__*/React.createElement(_button.UnstyledButton, {
      onClick: () => {
        onChange === null || onChange === void 0 ? void 0 : onChange(day);
      }
    }, dateString) : typeof dateString === "string" ? /*#__PURE__*/React.createElement("span", null, dateString) : dateString);
  }));
};

exports.WeekGrid = WeekGrid;

const CalendarHeader = ({
  size = "medium",
  className,
  date = new Date(),
  starts = 0
}) => {
  const week = (0, _eachWeekOfInterval.default)({
    start: date,
    end: date
  }, {
    weekStartsOn: starts
  });
  const days = (0, _range.default)(7).map(days => (0, _add.default)(week[0], {
    days
  }));
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.default)(_calendarModule.default.calendarHeader, _calendarModule.default[size], className)
  }, days.map(day => {
    const formattedDay = (0, _format.default)(day, "EEE");
    return /*#__PURE__*/React.createElement("div", {
      className: _calendarModule.default.dayHeader,
      key: formattedDay
    }, formattedDay);
  }));
};

exports.CalendarHeader = CalendarHeader;

function DayHeader({
  day,
  size
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.default)(_calendarModule.default.monthHeader, _calendarModule.default[size])
  }, /*#__PURE__*/React.createElement("h2", {
    className: _calendarModule.default.monthHeader
  }, formatDay(day, size)));
}

const LeftChevron = () => /*#__PURE__*/React.createElement("svg", {
  width: "8",
  height: "13",
  viewBox: "0 0 8 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.929688 6.3125C0.683594 6.55859 0.683594 6.96875 0.929688 7.21484L6.23438 12.5469C6.50781 12.793 6.91797 12.793 7.16406 12.5469L7.79297 11.918C8.03906 11.6719 8.03906 11.2617 7.79297 10.9883L3.58203 6.75L7.79297 2.53906C8.03906 2.26562 8.03906 1.85547 7.79297 1.60938L7.16406 0.980469C6.91797 0.734375 6.50781 0.734375 6.23438 0.980469L0.929688 6.3125Z",
  fill: "#05A6E4"
}));

exports.LeftChevron = LeftChevron;

const RightChevron = () => /*#__PURE__*/React.createElement("svg", {
  width: "8",
  height: "13",
  viewBox: "0 0 8 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.79297 7.21484C8.03906 6.96875 8.03906 6.55859 7.79297 6.3125L2.48828 0.980469C2.21484 0.734375 1.80469 0.734375 1.55859 0.980469L0.929688 1.60938C0.683594 1.85547 0.683594 2.26562 0.929688 2.53906L5.14062 6.75L0.929688 10.9883C0.683594 11.2617 0.683594 11.6719 0.929688 11.918L1.55859 12.5469C1.80469 12.793 2.21484 12.793 2.48828 12.5469L7.79297 7.21484Z",
  fill: "#05A6E4"
}));

exports.RightChevron = RightChevron;

const MonthPicker = ({
  value,
  onChange,
  size = "medium"
}) => {
  const date = value;
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.default)(_calendarModule.default.monthPicker, _calendarModule.default[size])
  }, /*#__PURE__*/React.createElement(MonthHeader, {
    date: value,
    size: size
  }), /*#__PURE__*/React.createElement("div", {
    className: _calendarModule.default.monthControls
  }, /*#__PURE__*/React.createElement(_button.UnstyledButton, {
    className: _calendarModule.default.monthSelector,
    onClick: () => onChange((0, _sub.default)(date, {
      months: 1
    }))
  }, /*#__PURE__*/React.createElement(LeftChevron, null)), /*#__PURE__*/React.createElement(_button.UnstyledButton, {
    className: _calendarModule.default.monthSelector,
    onClick: () => onChange((0, _add.default)(date, {
      months: 1
    }))
  }, /*#__PURE__*/React.createElement(RightChevron, null))));
};

exports.MonthPicker = MonthPicker;

const MonthHeader = ({
  date,
  size
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.default)(_calendarModule.default.monthHeader, _calendarModule.default[size])
  }, /*#__PURE__*/React.createElement("h2", {
    className: _calendarModule.default.monthHeader
  }, formatMonth(date)));
};

exports.MonthHeader = MonthHeader;

const VerticalWeekPicker = ({
  date,
  selectedDate,
  size,
  starts = 0,
  eventDates,
  onChange
}) => {
  const week = (0, _eachWeekOfInterval.default)({
    start: date,
    end: date
  }, {
    weekStartsOn: starts
  });
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.default)(_calendarModule.default.verticalWeekPicker, _calendarModule.default[size])
  }, /*#__PURE__*/React.createElement(MonthHeader, {
    date: date,
    size: "small"
  }), /*#__PURE__*/React.createElement(WeekGrid, {
    className: _calendarModule.default.weekColumn,
    selectedDate: selectedDate,
    eventDates: eventDates,
    size: size,
    firstDay: week[0],
    onChange: onChange,
    formatDate: d => /*#__PURE__*/React.createElement("div", {
      className: _calendarModule.default.dateString
    }, /*#__PURE__*/React.createElement("span", null, (0, _format.default)(d, "EEE")), /*#__PURE__*/React.createElement("span", null, (0, _format.default)(d, "M/d")))
  }));
};

exports.VerticalWeekPicker = VerticalWeekPicker;

const WeekPicker = ({
  date,
  size = "medium",
  starts = 0,
  eventDates,
  onChange,
  selectedDate,
  monthIndex,
  onPreviousWeekClick,
  onNextWeekClick
}) => {
  const week = (0, _eachWeekOfInterval.default)({
    start: date,
    end: date
  }, {
    weekStartsOn: starts
  });
  return /*#__PURE__*/React.createElement("div", {
    className: _calendarModule.default.weekPicker
  }, /*#__PURE__*/React.createElement(CalendarHeader, {
    size: size,
    date: date,
    starts: starts
  }), /*#__PURE__*/React.createElement("div", {
    className: _calendarModule.default.weekRow
  }, /*#__PURE__*/React.createElement(_button.UnstyledButton, {
    className: _calendarModule.default.weekSelector,
    onClick: onPreviousWeekClick
  }, /*#__PURE__*/React.createElement(LeftChevron, null)), /*#__PURE__*/React.createElement(WeekGrid, {
    size: size,
    firstDay: week[0],
    eventDates: eventDates,
    selectedDate: selectedDate,
    onChange: onChange
  }), /*#__PURE__*/React.createElement(_button.UnstyledButton, {
    className: _calendarModule.default.weekSelector,
    onClick: onNextWeekClick
  }, /*#__PURE__*/React.createElement(RightChevron, null))));
};

exports.WeekPicker = WeekPicker;

const WeekDateHeader = ({
  className,
  date,
  onPreviousClick,
  onNextClick
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.default)(_calendarModule.default.weekDateHeader, className)
  }, /*#__PURE__*/React.createElement(_button.UnstyledButton, {
    className: _calendarModule.default.weekSelector,
    onClick: onPreviousClick
  }, /*#__PURE__*/React.createElement(LeftChevron, null)), /*#__PURE__*/React.createElement(DayHeader, {
    day: date,
    size: "small"
  }), /*#__PURE__*/React.createElement(_button.UnstyledButton, {
    className: _calendarModule.default.weekSelector,
    onClick: onNextClick
  }, /*#__PURE__*/React.createElement(RightChevron, null)));
};

exports.WeekDateHeader = WeekDateHeader;

function formatMonth(date) {
  return date.toLocaleDateString(undefined, {
    month: "long",
    year: "numeric"
  });
}

function formatDay(date, size) {
  return date.toLocaleDateString(undefined, {
    weekday: "long",
    month: size === "small" ? "short" : "long",
    day: "numeric"
  });
}